<template>
    <main class="multi-radio-group" :class="{ 'active-require': showRequire }" :id="id">
        <!-- <h5 class="stem">
            问题 
			<span>{{ current }}</span>
			<span class="sub">/ {{ all }}</span>
        </h5> -->
        <div class="stem-title">
            <span class="index">{{ current }}. </span>
            <div class="title">
                <p class="content" :ref="id" v-html="title" style="display: inline;"></p>
                <span class="multi-flag">[多选题]</span>
            </div>
        </div>
        <p class="desc" v-html="desc"></p>
        <Radio
            v-for="(option, index) in options"
            :key="option.optionIdentifier"
            :title="`${index + 1}. ` + option.optionContent"
            :desc="option.optionDesc"
            :id="option.optionIdentifier"
            :value="getValue(option.optionIdentifier)"
            :option="option"
            @on-change="handleRadioChange"
        />
        <div v-if="showRequire" class="require-tip">{{ requireTip }}</div>
    </main>
</template>

<script>
import { mapState } from 'vuex';
import { ImagePreview } from 'vant';
import { QuestionRequire } from '@/libs/enum';
import Radio from './Radio';

export default {
    name: 'multi-radio-group',
    components: {
        Radio
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: null
        },
        desc: {
            type: String,
            default: null
        },
        options: {
            type: Array,
            default: () => [],
            require: true
        },
        all: {
            type: Number,
            default: 0
        },
        current: {
            type: Number,
            default: 0
        },
        require: {
            // 0 非必填; 1 必填。默认非必填
            type: String,
            default: () => QuestionRequire.no
        },
        id: {
            type: String,
            default: () => '',
            require: true
        },
        question: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState(['passValidate']),
        requireTip() {
            if (this.passValidate) {
                return this.passValidate.optionIdentifier
                    ? '此题选项为必填项，请完成'
                    : '此题为必填项，请完成';
            }
            return '此题为必填项，请完成';
        },
        showRequire() {
            if (this.passValidate && this.require === QuestionRequire.yes) {
                if (!this.checkOptions.length && this.passValidate.qidentifier) {
                    return true;
                }
                if (this.checkOptions.length && this.passValidate.optionIdentifier) {
                    let show = false;
                    for (let i = 0; i < this.checkOptions.length; i++) {
                        const option = this.options.find(
                            opt => this.passValidate.optionIdentifier === opt.optionIdentifier
                        );
                        if (option && !option.inputValue) {
                            show = true;
                            break;
                        }
                    }
                    return show;
                }
            }
            return false;
        }
    },
    watch: {
        value(n) {
            this.checkOptions = [...n];
        }
    },
    data() {
        return {
            checkOptions: this.value ? [...this.value] : []
        };
    },
    methods: {
        getValue(optionId) {
            if (this.checkOptions.indexOf(optionId) > -1) {
                return optionId;
            }
            return null;
        },
        handleRadioChange(isCheck, id) {
            if (isCheck) {
                if (this.checkOptions.indexOf(id) === -1) {
                    this.checkOptions.push(id);
                }
            } else {
                // 删除这个元素
                const index = this.checkOptions.indexOf(id);
                if (index > -1) {
                    this.checkOptions.splice(index, 1);
                }
            }
            this.$emit('input', this.checkOptions);
            this.$emit('on-change', this.checkOptions);
        },
        handleTitleImage(imageUrl) {
            if (imageUrl) {
                ImagePreview({
                    images: [imageUrl],
                    closeable: true
                });
            }
        }
    },
    mounted() {
        // 由于标题，图片是富文本动态渲染进去的，使用原生dom去进行查询访问
        const ref = this.$refs[this.id];
        if (ref) {
            ref.addEventListener(
                'click',
                e => {
                    this.handleTitleImage(e.target.src);
                },
                false
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.multi-radio-group {
    padding: 30px 40px;
    margin: 32px 32px;
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 32px;
    box-shadow: 0 8px 60px 10px rgba(46, 39, 39, 0.11);
    .stem {
        font-size: 32px;
        color: #ff530d;
        .sub {
            font-size: 26px;
        }
    }
    .stem-title {
        display: flex;
        font-size: 32px;
        .index {
            display: inline-block;
            padding-top: 22px;
            padding-right: 10px;
        }
    }
    .title {
        // display: flex;
        font-size: 36px;
        color: #333333;
        padding: 20px 0px;
        word-break: break-all;
        .multi-flag {
            margin-left: 10px;
            font-weight: 500;
        }
    }
    .desc {
        font-size: 28px;
        color: #999999;
        padding-bottom: 20px;
        word-break: break-all;
    }
    .require-tip {
        background-color: #ffe5e0;
        color: red;
        font-size: 28px;
        padding: 15px 0 15px 30px;
        text-align: left;
        border-radius: 5px;
    }
}
.active-require {
    border: dashed 2px red;
}
</style>

<style>
.multi-radio-group .title .content > p {
    display: inline;
}
.stem-title .title img {
    max-width: 100%;
    height: auto;
}
</style>
